import { createHashHistory } from 'history';

const history = createHashHistory();
history.listen(() => {
	// eslint-disable-next-line no-undef
	window.scrollTo(0, 0);
});

export default history;
